import React from 'react';
import ElectronSnipper from 'app/components/Snipper/ElectronSnipper';
import WebSnipper from 'app/components/Snipper/WebSnipper';
import type { LoadableImageFile } from 'app/interfaces/ImageLoader';
import getElectron from 'app/native/node/electron';

interface SnipperProps {
  onImageReady: (imageFiles: LoadableImageFile[]) => void;
}

function Snipper({ onImageReady }: SnipperProps) {
  if (getElectron()) {
    return <ElectronSnipper onImageReady={onImageReady} />;
  }

  return <WebSnipper onImageReady={onImageReady} />;
}

export default React.memo(Snipper);
